export default __webpack_public_path__ + "static/media/intro.fb957cce.jpg";